var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12" }, [
    _c(
      "div",
      { staticClass: "nav-tabs-wrapper nav-tabs-multiple coupled bb-0 card" },
      [
        _c(
          "ul",
          { staticClass: "nav nav-tabs scroll-container" },
          _vm._l(_vm.pages, function (page) {
            return _c(
              "li",
              {
                key: page.key,
                staticClass: "nav-item secondary",
                class: { "text-secondary bold": _vm.currentPage === page.key },
                attrs: { id: page.key },
                on: {
                  click: function ($event) {
                    return _vm.handlePageChange(page.key)
                  },
                },
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "nav-link grey-text text-darken-3 clickable",
                    attrs: {
                      to: { path: "/personal-settings/account/" + page.key },
                    },
                  },
                  [_vm._v("\n          " + _vm._s(page.label) + "\n        ")]
                ),
              ],
              1
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }